// eslint-disable-next-line import/prefer-default-export
export const addressDocumentUrlDownload = `${process.env.REACT_APP_PUBLIC_API_URL}/fintech/v1/documents/download?file_path=useful_files/declaracao_de_residencia.pdf`;
